// extracted by mini-css-extract-plugin
export default {"label":"FormItem_label__sE9MJ","content":"FormItem_content__lru77"};